import React, { FC, ReactElement } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { clsx } from 'clsx';
// Components
import Space from '../../../components/layout/space';
import BookingScreens from '../../../components/layout/bookingScreenContainer';
import ModalButton, { ButtonType } from '../../../components/modals/templates/modalButton';
import Text from '../../../components/text';
// Resources
import { stringsRes } from '../../../resources/strings';
import { PropsFromModal } from '../../../components/modals/createModalHOC';
import useGlobalStyles from '../../../components/hook/useGlobalStyles';

interface EditReservationWrapperProps extends PropsFromModal {
    children: React.ReactNode;
    description?: string;
    onCancel?: () => void;
    labelCancel?: string;
    onConfirm: () => void;
    labelConfirm?: string;
    loadingConfirm?: boolean;
    disableConfirm?: boolean;
    typeConfirm?: ButtonType;
    hideButtons?: boolean;
    noSpacing?: boolean;
    fixedHeight?: boolean;
    noCancel?: boolean;
    buttonsClassName?: string;
    childrenContainerClassName?: string;
}

const EditReservationWrapper: FC<EditReservationWrapperProps> = (props): ReactElement => {
    const classes = useStyles();
    const globalClasses = useGlobalStyles();

    const {
        hideButtons,
        description,
        children,
        onCancel,
        labelCancel,
        onConfirm,
        labelConfirm,
        loadingConfirm,
        disableConfirm,
        typeConfirm,
        onRequestClose,
        fixedHeight,
        noSpacing,
        noCancel,
        buttonsClassName,
        childrenContainerClassName,
    } = props;

    const onClose = (): void => {
        if (onCancel) {
            onCancel();
        }
        onRequestClose();
    };

    const onSave = (): void => {
        if (onConfirm) {
            onConfirm();
        }
    };

    // Wrap content in ResponsivePanel to have a stand alone page
    return (
        <BookingScreens>
            <div className={clsx(globalClasses.flexCol, childrenContainerClassName)}>
                {description && (
                    <>
                        <Text.Description16 text={description} customColor="grey" />
                        <Space value={3} />
                    </>
                )}
                {children}
            </div>
            {!noSpacing ? fixedHeight ? <div className={globalClasses.flex} /> : <Space value={4} /> : null}
            {!hideButtons && (
                <div className={clsx(classes.actionsContainer, buttonsClassName)}>
                    {!noCancel && (
                        <ModalButton
                            type={ButtonType.CANCEL}
                            onClick={onClose}
                            label={labelCancel ?? stringsRes.common.cancel}
                        />
                    )}
                    <ModalButton
                        type={typeConfirm ?? ButtonType.CONFIRM}
                        onClick={onSave}
                        disabled={disableConfirm ?? false}
                        label={labelConfirm ?? stringsRes.common.save}
                        isLoading={loadingConfirm}
                    />
                </div>
            )}
        </BookingScreens>
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        actionsContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
        },
    }),
);

export default EditReservationWrapper;
